module.exports = __webpack_public_path__ + "img/fr.8d0aa840.svg";